import React, {useState, useEffect} from 'react';
import { Table, Button, Space, Row, Col, Input} from 'antd';
import StudentInfoModal from './StudentInfoModal';
import moment from 'moment';
import {titleCase} from './GenFuncs';
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {Link} from 'react-router-dom';

  
export default function StudentTable () {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [dataIsLoading, setDataIsLoading] = useState(false);
  const [modalRowRecord, setModalRowRecord] = useState([]);
  const [modalIsEditing, setModalIsEditing] = useState(null);
  const [studentInfoDataSource, setStudentInfoDataSource] = useState([]);    


  const onCreate = (values) => {
    const newData = {
      firstName: values.firstName,
      lastName: values.lastName,
      dob: moment(values.dob).format("DD-MMM-YYYY"),
      age: values.age,
      gender: values.gender,
      contact: values.contact,
      gradeId: values.studentGrade,
      semesterId: values.studentSemester,
    }
    setDataIsLoading(true)
    fetch('https://kh-studentrecordsystem.herokuapp.com/studentsInfo', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(newData),
    })
      .then(response => response.json())
      .then(data => {
        fetch('https://kh-studentrecordsystem.herokuapp.com/studentsInfo')
          .then(response => response.json())
          .then(data => {
            setStudentInfoDataSource(data)
            setModalVisible(false);
            setDataIsLoading(false);
          })
      })
      .catch((error) => {console.error('Error:', error);});
  };

  useEffect(() => {
    fetch('https://kh-studentrecordsystem.herokuapp.com/studentsInfo')
      .then(response => response.json())
      .then(data => {setStudentInfoDataSource(data)})
      .catch(err => console.log(err))
  }, [])
      
//这是Antd的filter功能
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
        <Input
        ref={node => {
            this.searchInput = node;
        }}
        placeholder={titleCase(`Search ${dataIndex}`)}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
        <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
        >
            Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
        </Button>
        </Space>
    </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
    record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
    if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
    }
    },
    render: text =>
    searchedColumn === dataIndex ? (
        <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={searchText}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
        />
    ) : (
        text
    ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
      clearFilters();
      setSearchText(``);
  };

  const columns = [
    {
      title: 'Current Grade',
      dataIndex: 'studentGrade',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        let gradeA = a.studentGrade.toUpperCase();
        let gradeB = b.studentGrade.toUpperCase();
        if (gradeA < gradeB) {
          return -1;
        } else if (gradeA > gradeB) {
          return 1;
        } else {
          return 0;
        }
      },
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('studentGrade'),
    },
    {
      title: 'Current Semester',
      dataIndex: 'studentSemester',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        let semesterA = String(a.studentSemester).toUpperCase();
        let semesterB = String(b.studentSemester).toUpperCase();
        if (semesterA < semesterB) {
          return -1;
        } else if (semesterA > semesterB) {
          return 1;
        } else {
          return 0;
        }
      },
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('studentSemester'),
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        var firstNameA = a.firstName.toUpperCase();
        var firstNameB = b.firstName.toUpperCase();
        if (firstNameA < firstNameB) {
          return -1;
        } else if (firstNameA > firstNameB) {
          return 1;
        } else {
          return 0;
        }
      },
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('firstName'),
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        var lastNameA = a.lastName.toUpperCase();
        var lastNameB = b.lastName.toUpperCase();
        if (lastNameA < lastNameB) {
          return -1;
        } else if (lastNameA > lastNameB) {
          return 1;
        } else {
          return 0;
        }
      },
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('lastName'),
    },
    {
      title: 'Date Of Birth',
      dataIndex: "dob",
      ...getColumnSearchProps('dob'),
    },
    {
      title: 'Age',
      dataIndex: "age",
      ...getColumnSearchProps('age'),
    },
    {
      title: 'Gender',
      dataIndex: "gender",
      ...getColumnSearchProps('gender'),
    },
    {
      title: 'Emergency Contact',
      dataIndex: "contact",
      ...getColumnSearchProps('contact'),
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => ( 
        <Link to={`/studentsInfo/${record._id}`}>More Detail</Link>
      )
    },     
  ]

  return (
    <Row justify="center">
      <Col xs={23} lg={{span: 23, offset: 1}} xl={{span: 23, offset: 3}}>
        <div>
          <Button onClick={() => {setModalIsEditing(false); setModalVisible(true)}} type="primary" className="pageMainFuncBtn">Add New Student</Button>

          <Table
            rowKey={record => record._id}
            bordered
            dataSource={studentInfoDataSource}
            columns={columns}
            pagination={{defaultPageSize: 20}}
            loading={dataIsLoading}
          />

          <StudentInfoModal
            modalIsEditing={modalIsEditing}
            visible={modalVisible}
            record={modalRowRecord}
            onCreate={onCreate}
            onCancel={() => {
              setModalRowRecord(null)
              setModalVisible(false);
            }}
          />
        </div>
      </Col>
    </Row>
  );
};